import { hexToRgba } from '../utils'

export const palette = {
  burgundy1: '#97144D',
  burgundy2: '#ED1164',
  burgundy3: '#7E0E3F',
  burgundy4: '#97144E',
  burgundy5: '#ed116414',

  pink1: '#CB3073',
  pink2: '#ED116429',

  white: '#FFFFFF',
  whiteGrey: '#FAFAFA',
  whiteGrey2: '#D8D8D8',
  whiteGrey3: '#F0F0F0',
  whiteGrey4: '#F6F7F8',
  whiteGrey5: '#00000029',
  whiteGrey6: '#00000033',
  whiteGrey7: '#d6c8c8',

  black: '#000000',
  black2: '#3F3F3F',
  black3: '#4A4A4A',

  grey1: '#212121',
  grey2: '#6D6E71',
  grey3: '#939598',
  grey4: '#D8D8D8',
  grey5: '#EEEEEE',
  grey6: '#BAB9B9',
  grey7: '#868686',
  grey8: '#C4C4C4',
  grey9: '#AFAFAF',

  red1: '#FF0303',
  red2: '#FFF5F5',
  red3: '#FA9797',
  red4: '#BC4B4B',

  orange1: '#FC8800',
  orange2: '#FFEFD6',

  blue1: '#53B7E8',
  blue2: '#E9FAFF',
  blue3: '#007494',

  green1: '#02A552',
  green2: '#E5F6E6',
  green3: '#00A407',
  green4: '#59AA00'
}

export const colors = {
  primary: palette.burgundy1,
  secondary: palette.burgundy2,
  boxShadowColor: 'rgba(96, 96, 96, 0.2)',
  borderColor1: palette.grey5,
  borderColor2: palette.grey4,
  loaderBackground: '#F0F2F4',
  loaderForeground: '#E2E8EC',
  state: {
    success: {
      color: palette.green1,
      backgroundColor: palette.green2,
      shadowColor: hexToRgba(palette.green1, 0.2)
    },
    error: {
      color: palette.red1,
      backgroundColor: palette.red2,
      shadowColor: hexToRgba(palette.red1, 0.2)
    },
    info: {
      color: palette.blue1,
      backgroundColor: palette.blue2,
      shadowColor: hexToRgba(palette.blue1, 0.2)
    },
    warning: {
      color: palette.orange1,
      backgroundColor: palette.orange2,
      shadowColor: hexToRgba(palette.orange1, 0.2)
    }
  }
}
